import { getLastDriverPaymentRequest } from "./driverPaymentApi";

export const driverPaymentRepository = {
  async getLastByDriverId(driverId) {
    try {
      const response = await getLastDriverPaymentRequest(driverId);
      const payment = response.data?.data;
      if (response.data?.message !== "ok" || !payment || Array.isArray(payment) || typeof payment !== "object") {
        throw new Error("Invalid response");
      }
      return { success: true, data: payment.id != null ? payment : null, error: null };
    } catch (error) {
      return {
        success: false,
        data: null,
        error: "No se pudo cargar el último pago/cobro. Inténtalo nuevamente.",
      };
    }
  },
};
